const THREAD_PANEL_SIZE = {
  large: 300,
  medium: 200,
  small: 150,
};

const THREAD_PANEL_SHRINK_THRESHOLD = {
  medium: 600,
  small: 450,
};

export { THREAD_PANEL_SHRINK_THRESHOLD, THREAD_PANEL_SIZE };
